module.exports = __webpack_public_path__ + "bced1c46a24c3c2936010faecb1486ff.jpg";